import {Store} from '@gongxigames/framework/core/fragments/store/Store';

export type AnticipationTriggerConfig = {
    symbolId: number;
    triggerAmount: number;
    validReels?: number[];
};

export const ANTICIPATION_CONFIG = {
    anticipationTriggerConfig: [
        {
            symbolId: 11,
            triggerAmount: 3,
            validReels: [0, 1, 2, 3, 4]
        },
        {
            symbolId: 12,
            triggerAmount: 3,
        }],
    width: 3840,
    height: 2160
};
export const anticipatorStore = Store.createStore({
    anticipatedReels: Store.signal(null as never as number[]),
});